export default {
	alarm_action_failed: 'The reminder could not be confirmed. Please try again.',
	alarm_action_notification_cleanup_failed:
		'The reminder was confirmed, but the device notification could not be updated.',
	alarm_appointment: 'Remember your appointment',
	alarm_custom_date: 'To a specific time',
	alarm_date_label: 'Date',
	alarm_invalid_date_past: 'Please select a time in the future',
	alarm_remind_again_label: 'Remind again in...',
	alarm_remind_at_label: 'Remind me at...',
	alarm_remind_in_label: 'Remind me in...',
	alarm_reminder_title: 'Reminder',
	alarm_reminder_title_appointment: 'Reminder of your appointment',
	alarm_reminder_title_task: 'Reminder of your task',
	alarm_show: 'Show',
	alarm_snooze_1_day: 'In 1 day',
	alarm_snooze_1_hour: 'In 1 hour',
	alarm_snooze_2_hours: 'In 2 hours',
	alarm_snooze_4_hours: 'In 4 hours',
	alarm_snooze_5_min: 'In 5 minutes',
	alarm_snooze_15_min: 'In 15 minutes',
	alarm_snooze_30_min: 'In 30 minutes',
	alarm_snooze_ok: 'Ok',
	alarm_task: 'Remember your task',
	alarm_time_label: 'Time',
	alarm_time_suffix: "o'clock",
	alarm_title_label: 'Title',
};
